import React from "react";
import PropTypes from "prop-types";
import CustomButton from "components/common/Button";
import CustomTooltip from "components/common/Tooltip";
import "./ClockInBlockedCard.scss";

function ClockInBlockedCard({ mainHeading = null, subHeading = null, subText = null, action1 = null, action2 = null }) {
  const renderAction = (action) => {
    if (!action) return null;

    if (React.isValidElement(action)) {
      return action;
    }

    const button = (
      <CustomButton
        label={action.label}
        onClick={action.onClick}
        variant={action.variant || "contained"}
        color={action.color || "secondary"}
        size={action.size || "medium"}
        isDisabled={action.disabled}
        endIcon={action.endIcon}
      />
    );

    if (action.tooltip) {
      return (
        <CustomTooltip
          content={action.tooltip.content}
          direction={action.tooltip.direction || "top"}
          arrow={action.tooltip.arrow}
          className={action.tooltip.className}
          offset={action.tooltip.offset}
        >
          <span>{button}</span>
        </CustomTooltip>
      );
    }

    return button;
  };

  return (
    <div className="clock-in-blocked-card">
      <div className="clock-in-blocked-card__content">
        <div className="clock-in-blocked-card__text-section">
          {mainHeading && <p className="para-body-m-medium">{mainHeading}</p>}
          {subHeading && (
            <div className="clock-in-blocked-card__sub-heading-wrapper">
              <p className="heading-h2-semibold">{subHeading}</p>
              {subText && <p className="para-body-s-medium color-text-body-primary">{subText}</p>}
            </div>
          )}
        </div>

        <div className="clock-in-blocked-card__actions">
          {renderAction(action1)}
          {renderAction(action2)}
        </div>
      </div>
    </div>
  );
}

ClockInBlockedCard.propTypes = {
  mainHeading: PropTypes.string,
  subHeading: PropTypes.string,
  subText: PropTypes.string,
  action1: PropTypes.oneOfType([
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func,
      variant: PropTypes.string,
      color: PropTypes.string,
      size: PropTypes.string,
      disabled: PropTypes.bool,
      endIcon: PropTypes.node,
      tooltip: PropTypes.shape({
        content: PropTypes.node.isRequired,
        direction: PropTypes.string,
        arrow: PropTypes.bool,
        className: PropTypes.string,
        offset: PropTypes.arrayOf(PropTypes.number),
      }),
    }),
    PropTypes.element,
  ]),
  action2: PropTypes.oneOfType([
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func,
      variant: PropTypes.string,
      color: PropTypes.string,
      size: PropTypes.string,
      disabled: PropTypes.bool,
      endIcon: PropTypes.node,
      tooltip: PropTypes.shape({
        content: PropTypes.node.isRequired,
        direction: PropTypes.string,
        arrow: PropTypes.bool,
        className: PropTypes.string,
        offset: PropTypes.arrayOf(PropTypes.number),
      }),
    }),
    PropTypes.element,
  ]),
};

export default ClockInBlockedCard;
